import { Button, Grid } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { StyledSideNavigationBackButtonContent } from '../Styled/AppLayoutStyles';
import { Link } from 'react-router-dom';

const { useBreakpoint } = Grid;

const HeaderToolbar = () => {
  const screens = useBreakpoint();
  return (
    <>
      <img src='ecw_ces_logo.png' alt='East Coast Warehouse' height='45' style={{ margin: '0 16px' }} />
      <div style={{ flex: 1 }} />
      <Link to='https://eastcoastwarehouse.com' target='_blank'>
        <Button type='text' icon={<FontAwesomeIcon icon={solid('home')} size={'lg'} />}>
          <StyledSideNavigationBackButtonContent>
            <span className='prefix'>{screens.md && 'Back to'}</span>
            <span className='link'>eastcoastwarehouse.com</span>
          </StyledSideNavigationBackButtonContent>
        </Button>
      </Link>
    </>
  );
};

export default HeaderToolbar;
